import { render } from "./EditMarchandPage.vue?vue&type=template&id=0f17c23e&ts=true"
import script from "./EditMarchandPage.vue?vue&type=script&lang=ts"
export * from "./EditMarchandPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__